__turbopack_context__.v({
  "assistantMessage": "ChatAssistantWidget-module__sH9c8a__assistantMessage",
  "closeButton": "ChatAssistantWidget-module__sH9c8a__closeButton",
  "container": "ChatAssistantWidget-module__sH9c8a__container",
  "fab": "ChatAssistantWidget-module__sH9c8a__fab",
  "form": "ChatAssistantWidget-module__sH9c8a__form",
  "header": "ChatAssistantWidget-module__sH9c8a__header",
  "messages": "ChatAssistantWidget-module__sH9c8a__messages",
  "open": "ChatAssistantWidget-module__sH9c8a__open",
  "panel": "ChatAssistantWidget-module__sH9c8a__panel",
  "quickAction": "ChatAssistantWidget-module__sH9c8a__quickAction",
  "quickActionToggle": "ChatAssistantWidget-module__sH9c8a__quickActionToggle",
  "quickActions": "ChatAssistantWidget-module__sH9c8a__quickActions",
  "userMessage": "ChatAssistantWidget-module__sH9c8a__userMessage",
});
